import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getPriorities = (filters, token) =>
    axios({
        method: 'get',
        url: `${api}/tickets/installations/priorities?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    });
